import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

export default function ProductCardContent({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn("flex flex-col gap-0.5 px-3 py-2 text-left", className)}>
      {children}
    </div>
  );
}

ProductCardContent.displayName = "ProductCardContent";
